"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const getBackgroundColor_1 = __importDefault(require("./utils/getBackgroundColor"));
const getDecoratorBorderRadius_1 = __importDefault(require("./utils/getDecoratorBorderRadius"));
const InputWrapper = styled_components_1.default.div `
  background: ${getBackgroundColor_1.default};
  border-radius: ${({ theme, isSuffix, isPrefix }) => (0, getDecoratorBorderRadius_1.default)({ theme, isSuffix, isPrefix })};
  min-height: ${({ size, theme }) => {
    if (size === 'small') {
        return theme.heightSmall;
    }
    if (size === 'large') {
        return theme.heightLarge;
    }
    return theme.height;
}};
  display: flex;
  margin: ${({ theme }) => theme.verticalSpacing} 0;
  min-width: ${({ theme }) => theme.minWidth};
  width: ${({ fullWidth, theme }) => (fullWidth ? '100%' : theme.width)};
  cursor: ${({ isDisabled }) => isDisabled && 'not-allowed'};
`;
InputWrapper.displayName = 'InputWrapper';
exports.default = InputWrapper;
